import { SolanaToken } from '../interfaces/common'

const LEGACY_TOKEN_PROGRAM_ADDRESS = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA'

// these fees are approximate and are not guaranteed to cover every case (especially for Token 2022)
const SOLANA_ASSOCIATED_TOKEN_ACCOUNT_CREATION_FEE = 2050000n
const SOLANA_PROGRAM_2022_ASSOCIATED_TOKEN_ACCOUNT_CREATION_FEE = 3400000n
export const SOLANA_BASE_FEE = 5000n

export const getAssociatedTokenAccountCreationFee = (token: SolanaToken) => {
  if (token.additionalData.token_program_id === LEGACY_TOKEN_PROGRAM_ADDRESS) {
    return SOLANA_ASSOCIATED_TOKEN_ACCOUNT_CREATION_FEE
  } else {
    return SOLANA_PROGRAM_2022_ASSOCIATED_TOKEN_ACCOUNT_CREATION_FEE
  }
}
